export default "__VITE_ASSET__DSpa5x$i__"